import { ListItem } from '@rneui/themed'
import React from 'react'

interface TextRowProps {
  title: string
}

export function TextRow({ title }: TextRowProps) {
  return (
    <ListItem containerStyle={{ paddingVertical: 0 }}>
      <ListItem.Content>
        <ListItem.Title>{title}</ListItem.Title>
      </ListItem.Content>
    </ListItem>
  )
}
